import React from "react";
// import JoditEditor from "jodit-react";

import OftadehLayout from "../../components/OftadehLayout/OftadehLayout";
// import OftadehBreadcrumbs from "../../components/OftadehBreadcrumbs/OftadehBreadcrumbs";

// import InnerHTML from 'dangerously-set-html-content'
import { Button, Typography } from "@material-ui/core";

const AboutPage = props => {
  // const editor = useRef(null);
  // const [bodyPost, setBodyPost] = useState(
  //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus fermentum leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis feugiat vivamus at augue. At augue eget arcu dictum varius duis at consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa sapien faucibus et molestie ac."
  // );

  const { history } = props;


  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <OftadehLayout>
      <h1>Postprocessing</h1>
      <Typography color="textPrimary"variant="h6"> 
          Please wait till the simulation is done!
         </Typography>
         <Button
            onClick={() =>
              openInNewTab("https://vlab.daneshpark.org/results/")
              // openInNewTab("http://localhost:3000/results/")
            }
            variant="contained"
            color="default"
            size="small"
          >
            RUN
          </Button>
      {/* <InnerHTML html={
                   `
                   <div>This wil be rendered</div>
                   <py-script >
                   print('Hello')
                   </py-script>
               
                 `


                } /> */}
      {/* <OftadehBreadcrumbs path={history} /> */}
      {/* <JoditEditor
        ref={editor}
        value={bodyPost}
        config={{
          readonly: false,
          style: {
            height: "350px"
          }
        }}
        tabIndex={1}
        onBlur={value => setBodyPost(value)}
        onChange={value => {}}
      /> */}
    </OftadehLayout>
  );
};

export default AboutPage;
